const LS_KEY = 'mingo_notification_center';
const LS_SEEDED = 'mingo_notification_center_seeded';

function safeParse(json, fb) {
  try {
    const v = JSON.parse(json);
    return v == null ? fb : v;
  } catch {
    return fb;
  }
}

function seedDummy() {
  const now = Date.now();
  return [
    {
      id: 'n-d1',
      type: 'chat',
      title: '채팅',
      body: '미케초보맘님이 메시지를 보냈어요.',
      read: false,
      at: new Date(now - 120000).toISOString(),
      data: { href: '/chats' },
    },
    {
      id: 'n-d2',
      type: 'comment',
      title: '댓글',
      body: '게시글에 새 댓글이 달렸습니다.',
      read: false,
      at: new Date(now - 3600000).toISOString(),
      data: { href: '/community' },
    },
    {
      id: 'n-d3',
      type: 'like',
      title: '좋아요',
      body: '내 게시글에 좋아요가 추가되었습니다.',
      read: true,
      at: new Date(now - 7200000).toISOString(),
      data: { href: '/community' },
    },
    {
      id: 'n-d4',
      type: 'visa',
      title: '비자 만료',
      body: '설정한 비자 만료일이 30일 이내입니다.',
      read: false,
      at: new Date(now - 86400000).toISOString(),
      data: { href: '/settings/account' },
    },
    {
      id: 'n-d5',
      type: 'scam',
      title: '사기 경고',
      body: '새로운 지역 사기 경고가 등록되었습니다.',
      read: false,
      at: new Date(now - 172800000).toISOString(),
      data: { href: '/community' },
    },
  ];
}

export function getNotifications() {
  if (typeof window === 'undefined') return [];
  if (!window.localStorage.getItem(LS_SEEDED)) {
    window.localStorage.setItem(LS_KEY, JSON.stringify(seedDummy()));
    window.localStorage.setItem(LS_SEEDED, '1');
  }
  return safeParse(window.localStorage.getItem(LS_KEY), []);
}

export function saveNotifications(rows) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(LS_KEY, JSON.stringify(rows));
  window.dispatchEvent(new Event('mingo-notifications'));
}

export function markAllNotificationsRead() {
  const rows = getNotifications().map((r) => ({ ...r, read: true }));
  saveNotifications(rows);
}

export function markNotificationRead(id) {
  const rows = getNotifications().map((r) => (r.id === id ? { ...r, read: true } : r));
  saveNotifications(rows);
}

export function deleteNotification(id) {
  const rows = getNotifications().filter((r) => r.id !== id);
  saveNotifications(rows);
}

export function unreadNotificationCount() {
  return getNotifications().filter((r) => !r.read).length;
}
